import {
  Box,
  Card,
  CardContent,
  FormControl,
  InputLabel,
  MenuItem,
  Select,
  SelectChangeEvent,
  TextField,
} from "@mui/material"; // adapte les imports à ton projet
import { useMemo } from "react";
import { Shop, ShopStatusValue } from "../../model/Shop";

interface ShopFiltersProps {
  search: string;
  statusFilter: string;
  managerFilter: string;
  shops: Shop[];
  onSearchChange: (value: string) => void;
  onStatusChange: (value: string) => void;
  onManagerChange: (value: string) => void;
}

export default function ShopFilters({
  search,
  statusFilter,
  managerFilter,
  shops,
  onSearchChange,
  onStatusChange,
  onManagerChange,
}: ShopFiltersProps) {
  const uniqueManagers = useMemo(() => {
    const names = shops.map(
      (shop) => `${shop.manager.firstName} ${shop.manager.lastName}`,
    );
    return Array.from(new Set(names));
  }, [shops]);

  return (
    <Card>
      <CardContent>
        <Box sx={{ display: "flex", gap: 2, mb: 2, flexWrap: "wrap" }}>
          <TextField
            label="Recherche par nom"
            variant="outlined"
            size="small"
            value={search}
            onChange={(e) => onSearchChange(e.target.value)}
          />
          <FormControl size="small" sx={{ minWidth: 150 }}>
            <InputLabel>Status</InputLabel>
            <Select
              label="Status"
              value={statusFilter}
              onChange={(e: SelectChangeEvent) =>
                onStatusChange(e.target.value)
              }
              variant={"outlined"}
            >
              <MenuItem value="">Tous</MenuItem>
              {Object.entries(ShopStatusValue).map(([key, label]) => (
                <MenuItem key={key} value={key}>
                  {label}
                </MenuItem>
              ))}
            </Select>
          </FormControl>
          <FormControl size="small" sx={{ minWidth: 200 }}>
            <InputLabel>Commerçant</InputLabel>
            <Select
              label="Commerçant"
              value={managerFilter}
              onChange={(e: SelectChangeEvent) =>
                onManagerChange(e.target.value)
              }
              variant="outlined"
            >
              <MenuItem value="">Tous</MenuItem>
              {uniqueManagers.map((name) => (
                <MenuItem key={name} value={name}>
                  {name}
                </MenuItem>
              ))}
            </Select>
          </FormControl>
        </Box>
      </CardContent>
    </Card>
  );
}
